import React from 'react'
import './redmoreambpro.css';

const ReadMoreAmbPro = () => {
  return (
   <div className="why-tv">
        <p>The ClosesellerTv ambassadorship program offers students an opportunity to showcase their leadership skills, network with professionals, and enhance their resume. As an ambassador, you will be responsible for promoting ClosesellerTv on your campus and within your community through various marketing initiatives.</p>
        <h2>Benefits of being a ClosesellerTv ambassador:</h2>

        <ol type='1'>
            <li><span className='question-num'>1.</span>
            <span className='question-tit'> Leadership and skill development:</span>
            Gain hands-on experience in marketing, sales, and event management while honing your leadership skills.
                </li>
                
                <li><span className='question-num'>2.</span>
                <span className='question-tit'> Networking opportunities:</span>
                 Connect with professionals in the industry, attend exclusive events, and build valuable relationships that can help shape your future career.
                </li>

                <li><span className='question-num'>3.</span>
                <span className='question-tit'> Exclusive perks and rewards:</span>
                 Enjoy access to exclusive discounts, early product releases, and special promotions as a token of appreciation for your dedication.
                </li>

                <li><span className='question-num'>4.</span>
                <span className='question-tit'> Resume enhancement:</span>
                 Showcase your ambassadorship experience on your resume and stand out to potential employers.
                </li>
            </ol>

            <h2>Responsibilities of a ClosesellerTv ambassador:</h2>

            <ol type='1'>
            <li><span className='question-num'>1.</span>
            <span className='question-tit'> Promotion:</span>
             Raise awareness about ClosesellerTv through social media, word-of-mouth, and other creative marketing strategies.
                </li>
                
                <li><span className='question-num'>2.</span>
                <span className='question-tit'> Events and collaborations:</span> Organize and participate in campus events, workshops, and collaborations with student organizations to spread the word about ClosesellerTv.
                </li>

                <li><span className='question-num'>3.</span>
                <span className='question-tit'> Feedback and insights:</span>
                 Provide valuable feedback and insights to help improve our products and services.
                </li>

                <li><span className='question-num'>4.</span>
                <span className='question-tit'>Brand representation:</span>
                 Act as a brand ambassador by embodying the values and mission of ClosesellerTv.
                </li>
            </ol>


            <h2>Eligibility criteria:</h2>

            <ol type='1'>
            <li><span className='question-num'>1.</span>
                Must be a currently enrolled student at an accredited college or university.
                </li>
                
                <li><span className='question-num'>2.</span>
                Strong communication and interpersonal skills.
                </li>

                <li><span className='question-num'>3.</span>
                Active presence on social media platforms.
                </li>

                <li><span className='question-num'>4.</span>
                Passionate about sales and marketing.
                </li>
            </ol>

            <h2>Application Process:</h2>

            <li >
            To apply for the ClosesellerTv ambassadorship program, please visit our website and fill out the application form. Selected candidates will be contacted for an interview to assess their suitability for the program.
            </li>

            <li>
            Join us in spreading the word about ClosesellerTv and gain valuable experience as a student ambassador. Together, let's revolutionize the industry!
            </li>
   </div>
  )
}

export default ReadMoreAmbPro